<template>
    <div>
        <b-container class="bv-example-row">
        <br>
        <b-row>
            <b-col> <b-link to="/select"><b-img thumbnail src="./mousedev.png" fluid alt="Responsive image"></b-img></b-link> </b-col>
        </b-row>


        </b-container>
    </div>
</template>

<script>
    export default {
       name: "Home" ,
    }
</script>

<style lang="scss" scoped>

</style>